<!-- eslint-disable @stylistic/max-len -->

<script setup lang="ts">
const { stroke = '1.1' } = defineProps<{
  stroke?: '1.5' | '1.1'
}>()
</script>

<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" :stroke-width="stroke" stroke="currentColor">
    <path d="M4 21C7.76471 13 16.2353 13 20 21" stroke-linecap="round" />
    <circle cx="12" cy="9" r="5.4" />
  </svg>
</template>
